import { Helmet } from 'react-helmet-async';

export function SEO({ 
  title = "Baklight — Film Production Mexico | Cinematic Storytelling",
  description = "Director-led production ecosystem in Mexico. International production services, cinematic color grading, documentary & commercial filmmaking.",
  path = "",
  image = "/assets/og-image.jpg",
  type = "website",
  author = "Paco Herrera",
  publishedTime = null,
  modifiedTime = null,
  keywords = null
}) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://baklight.emergent.host';
  const url = `${baseUrl}${path}`;
  const fullImageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;
  
  const defaultKeywords = "film production mexico, cinematic color grading, international production services, documentary cinematography, commercial filmmaking mexico, tequila brand films, jalisco production company, davinci resolve mexico, film equipment rental guadalajara, mexico film director";
  const finalKeywords = keywords || defaultKeywords;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Baklight" />
      <meta property="og:locale" content="en_US" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {type === 'article' && <meta property="article:author" content={author} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:creator" content="@baklight" />
      <meta name="twitter:site" content="@baklight" />
      
      {/* Keywords for Google */}
      <meta name="keywords" content={finalKeywords} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="MX-JAL" />
      <meta name="geo.placename" content="Guadalajara, Jalisco, Mexico" />
      <meta name="geo.position" content="20.6597;-103.3496" />
      <meta name="ICBM" content="20.6597, -103.3496" />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="format-detection" content="telephone=no" />
      
      {/* Language and Region */}
      <meta httpEquiv="content-language" content="en" />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="es" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
    </Helmet>
  );
}
